import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import WalletService from './components/WalletService';
import BlockExplorer from './components/BlockExplorer';
import MetricsDashboard from './components/MetricsDashboard';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Nockchain gRPC Explorer</h1>
          <p>Explore and interact with the Nockchain blockchain API</p>
        </header>

        <Nav />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<WalletService />} />
            <Route path="/wallet" element={<WalletService />} />
            <Route path="/blocks" element={<BlockExplorer />} />
            <Route path="/metrics" element={<MetricsDashboard />} />
          </Routes>
        </main>

        <footer className="App-footer">
          <p>Connected to: <code>https://rpc.nockchain.net</code></p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
